module.exports = __webpack_public_path__ + "img/55_48.81090d46.png";